module.exports = __webpack_public_path__ + "static/media/Pic-0082.96fd40b5.jpg";